const $$splitComponentImporter = () => import('/home/runner/work/inspecttec-frontend-admin/inspecttec-frontend-admin/src/routes/admin-roles/$roleId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
import { Permissions } from "@/constants/permissions";
import { requirePermission } from "@/lib/auth/permission-guard";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/admin-roles/$roleId")({
  beforeLoad: args => requirePermission(Permissions.System.ManageRoles, args),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});